import { useState } from 'react';
import classNames from 'classnames';
import { Lock } from '@mui/icons-material';
import {
  VibeButton,
} from 'vibeguide';
import PasswordRequirements from '../Shared/Password/PasswordRequirements';

function FirstTimeLoginForm({
  errors = {},
  onFirstTimeChangePassword = () => {},
  passwordValidateChange = () => {},
}) {
  const [password, setPassword] = useState('');
  const [isPasswordFocus, setIsPasswordFocus] = useState(false);

  const onPasswordChange = (e) => {
    const {
      target: {
        value,
      },
    } = e;

    setPassword(value);
    passwordValidateChange(e);
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      onFirstTimeChangePassword(e);
    }
  };

  return (
    <div className="ResetPasswordForm">
      <div className="form-title">
        First time logging in?

        <div className="form-subtitle">
          Please provide a new password.
        </div>
      </div>

      <form>
        <div className={classNames('input-container', { active: isPasswordFocus })}>
          <input
            id="first_time_password"
            className="login-input"
            type="password"
            placeholder="New Password"
            value={password}
            onChange={onPasswordChange}
            onKeyDown={onKeyDown}
            onFocus={() => setIsPasswordFocus(true)}
            onBlur={() => setIsPasswordFocus(false)}
            data-testid="first-time-login-new-password-input"
          />

          <Lock className="login-icon password-icon" />
        </div>
      </form>

      <PasswordRequirements errors={errors} />

      <VibeButton
        style={{
          width: '100%',
        }}
        text="Reset Password"
        color="primary"
        disabled={errors.errors}
        testId="first-time-login-submit-button"
        onClick={onFirstTimeChangePassword}
      />
    </div>
  );
}

export default FirstTimeLoginForm;
